import React, { useEffect } from 'react';
import { LoggerModule } from '@vlinder-web/logger-module-react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let rejectedDocumentsApplicationMachine: any;

const MODULE_NAME = 'machines.rejectedDocumentsApplication';
const log: any = LoggerModule?.getInstance();

export const useSMRejectedDocumentsApplication = (_context: any) => {
  console.log('qqqmachineentered');
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  rejectedDocumentsApplicationMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(rejectedDocumentsApplicationMachine);

  return {
    rejectedDocumentsApplicationMachine,
    rejectedDocumentsApplicationState: state,
    rejectedDocumentsApplicationSend: send,
  };
};
